import React, { useState, useEffect } from "react";
import axios from "../../APIs/axios";
import { config } from "../../config";
import Select from "react-select";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import { getAccountDetails } from "../Services/localStorage";

const CmvElectricalDashboard = ({ allReports }) => {
  const [orgList, setOrgList] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [siteOptions, setSiteOptions] = useState(null);
  const { userId } = getAccountDetails();

  const initialScores = [
    { id: 1, parameter: "Design & Installation", MaximumScore: 0, ScoreObtained: 0 },
    { id: 2, parameter: "Preventive Maintenance", MaximumScore: 0, ScoreObtained: 0 },
    { id: 3, parameter: "Training", MaximumScore: 0, ScoreObtained: 0 },
    { id: 4, parameter: "Lock out Tag out (LOTO)", MaximumScore: 0, ScoreObtained: 0 },
    { id: 5, parameter: "Drawings (As- built) /Documents", MaximumScore: 0, ScoreObtained: 0 },
  ];

  const [scores, setScores] = useState(initialScores);

  const initialCmvScores = [
    { id: 1, parameter: "Design & Installation", newScore: 0 },
    { id: 2, parameter: "Preventive Maintenance", newScore: 0 },
    { id: 3, parameter: "Training", newScore: 0 },
    { id: 4, parameter: "Lock out Tag out (LOTO)", newScore: 0 },
    { id: 5, parameter: "Drawings (As- built) /Documents", newScore: 0 },
  ];

  const [cmvScores, setCmvScores] = useState(initialCmvScores);
  const [showNewScore, setShowNewScore] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let params = { user_id: userId };
        if (selectedOrganization) params.organization = selectedOrganization.label;
        if (selectedSite) params.site = selectedSite.label;
        if (selectedReportId) params.report_id = selectedReportId.label;

        const res = await axios.get(
          `${config.PATH}/api/electrical-dashboard-score`,
          { params }
        );

        const updatedScores = [...initialScores];

        res.data.forEach(report => {
          report.scores.forEach(score => {
            const idx = updatedScores.findIndex(row => row.id === score.id);

            if (idx !== -1) {
              updatedScores[idx].MaximumScore += score.MaximumScore;
              updatedScores[idx].ScoreObtained += score.ScoreObtained;
            }
          });
        });

        setScores(updatedScores);
      } catch (err) {
        console.error("Error fetching scores:", err.message);
        setScores(initialScores);
      }
    };

    fetchData();
  }, [selectedOrganization, selectedSite, selectedReportId, userId]);

  useEffect(() => {
    const fetchCmvScores = async () => {
      try {
        let params = { user_id: userId };
        if (selectedOrganization) params.organization = selectedOrganization.label;
        if (selectedSite) params.site = selectedSite.label;
        if (selectedReportId) params.report_id = selectedReportId.label;

        const res = await axios.get(
          `${config.PATH}/api/cmv-electrical-dashboard-score`,
          { params }
        );

        setShowNewScore(res.data?.length > 0);

        const updatedCmv = [...initialCmvScores];

        res.data.forEach(report => {
          report.scores.forEach(score => {
            const idx = updatedCmv.findIndex(row => row.id === score.id);

            if (idx !== -1) {
              updatedCmv[idx].newScore += score.ScoreObtained;
            }
          });
        });

        setCmvScores(updatedCmv);
      } catch (err) {
        console.error("Error fetching CMV scores:", err.message);
        setShowNewScore(false);
        setCmvScores(initialCmvScores);
      }
    };

    fetchCmvScores();
  }, [selectedOrganization, selectedSite, selectedReportId, userId]);

  const getOrgList = async () => {
    try {
      const res = await axios.get(`${config.PATH}/api/organizations`);
      const filtered = res.data.filter(o => o.report_created === 1);
      setOrgList(filtered);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  useEffect(() => {
    getOrgList();

    const fetchSites = async (orgId) => {
      try {
        const res = await axios.get(`${config.PATH}/api/organizations/${orgId}/sites`);
        const sites = res.data.filter(s => s.report_created === true);
        setSiteOptions(sites.map(s => ({ label: s.site_name, value: s.site_name })));
      } catch (error) {
        console.log("Error:", error);
      }
    };

    if (selectedOrganization) fetchSites(selectedOrganization.value);
  }, [selectedOrganization]);
  return (
    <div>
      <div className="electrical-org-site-container">
        <div className="electrical-select-wrapper">
          <Select
            options={orgList.map(org => ({ label: org.org_name, value: org.id }))}
            placeholder="Select Organization"
            onChange={opt => { setSelectedOrganization(opt); setSelectedSite(null); setSelectedReportId(null); }}
            isClearable
          />
        </div>

        <div className="electrical-select-wrapper">
          <Select
            options={siteOptions}
            placeholder="Select Site"
            value={selectedSite}
            onChange={setSelectedSite}
            isClearable
            isDisabled={!selectedOrganization}
          />
        </div>

        <div className="electrical-select-wrapper">
          <Select
            options={allReports.length && allReports
              .filter(r =>
                (!selectedOrganization || r.org_id === selectedOrganization.value) &&
                (!selectedSite || r.site === selectedSite.value)
              )
              .map(r => ({ label: r.report_id, value: r.report_id }))
            }
            placeholder="Report ID"
            onChange={setSelectedReportId}
            value={selectedReportId}
            isClearable
            isDisabled={!selectedSite}
          />
        </div>
      </div>

      <div className="dashboard-table-container">
        {!selectedReportId && (
          <p>Kindly select above parameter ⬆️ to see report details</p>
        )}

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow style={{ background: "grey" }}>
                <TableCell>Parameter</TableCell>
                <TableCell>Max Score</TableCell>
                <TableCell>Score Obtained</TableCell>
                {showNewScore && <TableCell>New Score Obtained</TableCell>}
              </TableRow>
            </TableHead>

            <TableBody>
              {scores.map(row => {
                const cmvRow = cmvScores.find(c => c.id === row.id);
                return (
                  <TableRow key={row.id}>
                    <TableCell>{row.parameter}</TableCell>
                    <TableCell>{row.MaximumScore}</TableCell>
                    <TableCell>
                      {/* {row.ScoreObtained > 0
                        ? row.ScoreObtained.toFixed(2)
                        : 0} */}
                        {Number(row.ScoreObtained || 0).toFixed(2)}

                    </TableCell>

                    {showNewScore && (
                      <TableCell>
                        {cmvRow?.newScore > 0
                          ? cmvRow.newScore.toFixed(2)
                          : 0}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}

              {/* Cumulative Row */}
              <TableRow style={{ background: "#efc71d" }}>
                <TableCell>Cumulative</TableCell>

                <TableCell style={{ fontWeight: "bold" }}>
                  {scores.reduce((a, r) => a + r.MaximumScore, 0)}
                </TableCell>

                <TableCell style={{ fontWeight: "bold" }}>
                  {/* {scores.reduce((a, r) => a + r.ScoreObtained, 0).toFixed(2)} */}
                  {scores.reduce((a, r) => a + Number(r.ScoreObtained || 0), 0).toFixed(2)}

                </TableCell>

                {showNewScore && (
                  <TableCell style={{ fontWeight: "bold" }}>
                    {cmvScores
                      .reduce((a, r) => a + r.newScore, 0)
                      .toFixed(2)}
                  </TableCell>
                )}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default CmvElectricalDashboard;
